
div.cms .cms-structure.cms-structure-condensed {
  right: 0 !important;
}

html:not(.dont-hide-django-cms-toolbar) {
  div.cms .cms-toolbar {
    top: -30px !important;
    background-color: black;

    transition: top 0.05s ease-in-out, background-color 0.05s ease-in-out;

    &:hover {
      top: 0px !important;
      background-color: white;
    }
  }
}
